import { compact } from '@lglp/utils';
import { schema } from 'normalizr';

import { date } from '../../../../../helpers/compact';
import { LinkDocument, LinkType } from '../../../../../types';
import { Document, DocumentType } from '../../../../../types/document';
import { toBoolean } from '../../../fields/boolean';
import { toDocType } from '../../../mapping';

let deprecatedDocumentInfo: Record<string, Record<string, any>> = {};

export const getDeprecatedDocumentInfo = () => {
  return deprecatedDocumentInfo;
};

const getDocumentLink = (doc: any): LinkDocument =>
  compact<LinkDocument>({
    ...doc,
    linkType: LinkType.LINK_TYPE_DOC,
    type: toDocType(doc?.type),
  });

const processDocument: schema.StrategyFunction<Document> = (doc) =>
  compact<Document>({
    id: doc.id,
    uid: doc.uid,
    type: toDocType(doc.type),
    lang: doc.lang,
    alternateLanguages: doc.alternate_languages?.map(getDocumentLink),
    createdAt: date(
      doc.data?.publication_date || doc.first_publication_date,
      'YYYY-MM-DDTHH:mm:ssZ'
    ),
    updatedAt: date(doc.last_publication_date, 'YYYY-MM-DDTHH:mm:ssZ'),
    disableRgpbBanner: toBoolean(doc.disableRgpd),
  });

/**
 * Function to transform a prismic custom types to a document.
 */
export const documentEntity = <T extends Document = Document>(
  type: DocumentType,
  { processStrategy, ...rest }: schema.EntityOptions<T>
): schema.Entity<T> =>
  new schema.Entity<T>(
    type,
    {},
    {
      idAttribute: 'id',
      processStrategy: (entity, parent, key) => {
        if (!entity) {
          return undefined;
        }

        if (entity?.tags?.indexOf('Obsolète') >= 0) {
          if (!deprecatedDocumentInfo[type]) {
            deprecatedDocumentInfo[type] = {};
          }
          deprecatedDocumentInfo = {
            ...deprecatedDocumentInfo,
            [type]: {
              ...deprecatedDocumentInfo[type],
              [entity?.uid]: entity.first_publication_date,
            },
          };
          return undefined;
        }

        return processStrategy !== undefined
          ? {
              ...processDocument(entity, parent, key),
              ...processStrategy(entity, parent, key),
            }
          : (processDocument(entity, parent, key) as T);
      },
      ...rest,
    }
  );
